export enum PaymentOrigin {
  'BLOCKCHAIN' = 'BLOCKCHAIN',
  'INTERNAL' = 'INTERNAL',
  'MANUAL' = 'MANUAL'
}
